/**
 * LE DUE FOTO DEL CLIENTE (Týpos, 14 ott 2026). Davide: «quando premi Salva tagli voglio nello zip l'immagine caricata o
 * scattata dall'utente e l'immagine elaborata prima di essere caricata su ShapeDiver».
 * Il pannello foto (EidosFotoComponent) le scrive qui quando il cliente sceglie o scatta una foto; "Salva tagli"
 * (EidosSalvaTagli) le legge e le manda al servizio, che le mette nello zip.
 */
export const fotoCliente: {originale: File | null; stencil: File | null} = {originale: null, stencil: null};

export function ricordaFotoCliente(originale: File | null, stencil: File | null) {
	fotoCliente.originale = originale;
	fotoCliente.stencil = stencil;
}

/** il file in base64 (senza il prefisso "data:...;base64,") */
export function inBase64(f: File): Promise<string> {
	return new Promise((ok, ko) => {
		const r = new FileReader();
		r.onload = () => {
			const s = String(r.result || "");
			ok(s.slice(s.indexOf(",") + 1));
		};
		r.onerror = () => ko(r.error);
		r.readAsDataURL(f);
	});
}
